import { ClientInfo, ClientJobInfo, Contacts } from '../../entities';

const SecondStep: React.FC = () => {
  return (
    <div className="ie-second-step">
      <ClientInfo />
      <ClientJobInfo />
      <Contacts />
    </div>
  );
};

export default SecondStep;
